const managerExcludeIds = ['coupons', 'bonuses'];
const moderatorExcludeIds = [
  'business_settings',
  'transaction_management',
  'report_and_analytics',
];

const filterRoutes = (routes, excludeIds) => {
  return routes
    .filter((route) => !excludeIds.includes(route.id))
    .map((route) => {
      const newRoute = { ...route };

      // Handle menus in group type routes
      if (newRoute.menus) {
        newRoute.menus = filterRoutes(newRoute.menus, excludeIds);
      }

      // Handle children in parent type routes
      if (newRoute.children) {
        newRoute.children = filterRoutes(newRoute.children, excludeIds);
      }

      return newRoute;
    });
};

const parcelRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    type: 'single',
  },
  {
    name: 'order.management',
    id: 'order_management',
    type: 'group',
    menus: [
      {
        name: 'all',
        url: 'parcel-orders',
        icon: 'orders',
        id: 'all_orders',
        type: 'single',
      },
      {
        name: 'parcel.types',
        id: 'parcel_types',
        icon: 'parcel_types',
        url: 'parcel-types',
        type: 'single',
      },
      {
        name: 'options',
        id: 'options',
        icon: 'options',
        url: 'options',
        type: 'single',
      },
      {
        name: 'order.statuses',
        id: 'order_statuses',
        icon: 'order_statuses',
        url: 'settings/orderStatus',
        type: 'single',
      },
    ],
  },
  {
    name: 'deliverymen.management',
    id: 'deliverymen_management',
    type: 'group',
    menus: [
      {
        name: 'deliveryman.list',
        id: 'deliveryman_list',
        icon: 'deliveryman_list',
        url: 'deliveries/list',
        type: 'single',
      },
      {
        name: 'deliveryman.map',
        id: 'deliveryman_map',
        icon: 'deliveryman_map',
        url: 'deliveries/map',
        type: 'single',
      },
      {
        name: 'deliveryman.statistics',
        id: 'deliveryman_statistics',
        icon: 'deliveryman_statistics',
        url: 'delivery/statistics',
        type: 'single',
      },
      {
        name: 'deliveryman.reviews',
        id: 'deliveryman_reviews',
        icon: 'deliveryman_reviews',
        url: 'reviews/deliveryboy',
        type: 'single',
      },
      {
        name: 'deliveryman.requests',
        id: 'deliveryman_requests',
        icon: 'deliveryman_requests',
        url: 'deliveryman/request',
        type: 'single',
      },
    ],
  },
];

const adminRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    type: 'single',
  },
  {
    name: 'pos',
    icon: 'pos',
    url: 'pos-system',
    id: 'pos',
    type: 'single',
  },
  {
    name: 'delivery.point',
    icon: 'delivery_point',
    url: 'delivery-point',
    id: 'delivery_point',
    type: 'single',
  },
  {
    name: 'warehouse',
    icon: 'warehouse',
    url: 'warehouse',
    id: 'warehouse',
    type: 'single',
  },
  {
    name: 'delivery.price',
    icon: 'delivery_price',
    url: 'delivery-price',
    id: 'delivery_price',
    type: 'single',
  },
  {
    name: 'order.management',
    id: 'order_management',
    type: 'group',
    menus: [
      {
        name: 'orders',
        id: 'orders',
        icon: 'orders',
        type: 'parent',
        children: [
          {
            name: 'all',
            url: 'orders',
            id: 'all_orders',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'warehouse.orders',
            url: 'orders-board',
            id: 'warehouse_orders',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'seller.orders',
            url: 'orders/seller',
            id: 'seller_orders',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'delivery.orders',
            url: 'orders-board/delivery',
            id: 'delivery_orders',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'point.orders',
            url: 'orders-board/point',
            id: 'point_orders',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'refund.orders',
            url: 'refunds',
            id: 'refund_orders',
            type: 'single',
            parentId: 'orders',
          },
        ],
      },
      {
        name: 'order.statuses',
        id: 'order_statuses',
        icon: 'order_statuses',
        url: 'settings/orderStatus',
        type: 'single',
      },
    ],
  },
  {
    name: 'delivery.zone.management',
    id: 'delivery_zone_management',
    type: 'group',
    menus: [
      {
        name: 'regions',
        id: 'regions',
        icon: 'location',
        url: 'deliveryzone/region',
        type: 'single',
      },
      {
        name: 'countries',
        id: 'countries',
        icon: 'location',
        url: 'deliveryzone/country',
        type: 'single',
      },
      {
        name: 'cities',
        id: 'cities',
        icon: 'location',
        url: 'deliveryzone/city',
        type: 'single',
      },
      {
        name: 'areas',
        id: 'areas',
        icon: 'location',
        url: 'deliveryzone/area',
        type: 'single',
      },
    ],
  },
  {
    name: 'shop.management',
    id: 'shop_management',
    type: 'group',
    menus: [
      {
        name: 'shops',
        id: 'shops',
        icon: 'shops',
        url: 'shops',
        type: 'single',
      },
      {
        name: 'shop.tags',
        id: 'shops_tags',
        icon: 'shops_tags',
        url: 'shop-tag',
        type: 'single',
      },
      {
        name: 'shop.reviews',
        id: 'shops_reviews',
        icon: 'reviews',
        url: 'shop-reviews',
        type: 'single',
      },
    ],
  },
  {
    name: 'product.management',
    id: 'product_management',
    type: 'group',
    menus: [
      {
        name: 'products',
        id: 'products',
        icon: 'products',
        url: 'catalog/products',
        type: 'single',
      },
      {
        name: 'categories',
        id: 'product_categories',
        icon: 'product_categories',
        url: 'catalog/categories',
        type: 'single',
      },
      {
        name: 'brands',
        id: 'brands',
        icon: 'brands',
        url: 'catalog/brands',
        type: 'single',
      },
      {
        name: 'units',
        id: 'units',
        icon: 'units',
        url: 'catalog/units',
        type: 'single',
      },
      {
        name: 'looks',
        id: 'looks',
        icon: 'looks',
        url: 'catalog/looks',
        type: 'single',
      },
      {
        name: 'extras',
        id: 'options',
        icon: 'options',
        type: 'parent',
        children: [
          {
            name: 'extra.groups',
            url: 'catalog/extras',
            id: 'option_group',
            type: 'single',
            parentId: 'options',
          },
          {
            name: 'extra.values',
            url: 'catalog/extras/value',
            id: 'option_value',
            type: 'single',
            parentId: 'options',
          },
        ],
      },
      {
        name: 'properties',
        id: 'properties',
        icon: 'properties',
        type: 'parent',
        children: [
          {
            name: 'property.groups',
            url: 'catalog/properties',
            id: 'property_group',
            type: 'single',
            parentId: 'properties',
          },
          {
            name: 'property.values',
            url: 'catalog/properties/value',
            id: 'property_value',
            type: 'single',
            parentId: 'properties',
          },
        ],
      },
      {
        name: 'product.reviews',
        id: 'product_reviews',
        icon: 'reviews',
        url: 'reviews/product',
        type: 'single',
      },
    ],
  },
  {
    name: 'content.management',
    id: 'content_management',
    type: 'group',
    menus: [
      {
        name: 'careers',
        id: 'careers',
        icon: 'careers',
        type: 'parent',
        children: [
          {
            name: 'career.list',
            url: 'catalog/career',
            id: 'career_list',
            type: 'single',
            parentId: 'careers',
          },
          {
            name: 'career.categories',
            url: 'catalog/career-categories',
            id: 'career_categories',
            type: 'single',
            parentId: 'careers',
          },
        ],
      },
      {
        name: 'blogs',
        url: 'blogs',
        icon: 'blogs',
        id: 'blogs',
        type: 'single',
      },
      {
        name: 'stories',
        icon: 'stories',
        url: 'stories',
        id: 'stories',
        type: 'single',
      },
      {
        name: 'gallery',
        url: 'gallery',
        icon: 'gallery',
        id: 'gallery',
        type: 'single',
      },
    ],
  },
  {
    name: 'promotion.management',
    id: 'promotion_management',
    type: 'group',
    menus: [
      {
        name: 'banners',
        icon: 'banners',
        url: 'banners',
        id: 'banners',
        type: 'single',
      },
      {
        name: 'ads',
        id: 'ads',
        icon: 'ads',
        type: 'parent',
        children: [
          {
            name: 'ad.list',
            url: 'catalog/advert',
            id: 'ad_list',
            type: 'single',
            parentId: 'ads',
          },
          {
            name: 'shop.ad.list',
            url: 'catalog/shop-ads',
            id: 'shop_ad_list',
            type: 'single',
            parentId: 'ads',
          },
        ],
      },
      {
        name: 'cashback',
        icon: 'deliveryman_payments',
        url: 'cashback',
        id: 'cashback',
        type: 'single',
      },
      {
        name: 'referral',
        icon: 'referral',
        url: 'settings/referal',
        id: 'referral',
        type: 'single',
      },
      {
        name: 'bonuses',
        icon: 'bonuses',
        url: 'bonus/list',
        id: 'bonuses',
        type: 'single',
      },
      {
        name: 'coupons',
        icon: 'coupons',
        url: 'coupons',
        id: 'coupons',
        type: 'single',
      },
      {
        name: 'notifications',
        icon: 'notifications',
        url: 'notifications',
        id: 'notifications',
        type: 'single',
      },
    ],
  },
  {
    name: 'user.management',
    id: 'user_management',
    type: 'group',
    menus: [
      {
        name: 'customers',
        url: 'users/user',
        id: 'customers',
        icon: 'customers',
        type: 'single',
      },
      {
        name: 'staff.&.admin.users',
        url: 'users/admin',
        id: 'staff_and_admin_users',
        icon: 'staff_and_admin_users',
        type: 'single',
      },
      {
        name: 'deliverymen',
        id: 'deliverymen',
        icon: 'deliverymen',
        type: 'parent',
        children: [
          {
            name: 'deliveryman.list',
            id: 'deliveryman_list',
            icon: 'deliveryman_list',
            url: 'deliveries/list',
            type: 'single',
          },
          {
            name: 'deliveryman.map',
            id: 'deliveryman_map',
            icon: 'deliveryman_map',
            url: 'deliveries/map',
            type: 'single',
          },
          {
            name: 'deliveryman.statistics',
            id: 'deliveryman_statistics',
            icon: 'deliveryman_statistics',
            url: 'delivery/statistics',
            type: 'single',
          },
          {
            name: 'deliveryman.reviews',
            id: 'deliveryman_reviews',
            icon: 'deliveryman_reviews',
            url: 'reviews/deliveryboy',
            type: 'single',
          },
          {
            name: 'deliveryman.requests',
            id: 'deliveryman_requests',
            icon: 'deliveryman_requests',
            url: 'deliveryman/request',
            type: 'single',
          },
        ],
      },
      {
        name: 'wallets',
        icon: 'wallets',
        url: 'wallets',
        id: 'wallets',
        type: 'single',
      },
    ],
  },
  {
    name: 'transaction.management',
    id: 'transaction_management',
    type: 'group',
    menus: [
      {
        name: 'transactions',
        icon: 'transactions',
        url: 'transactions',
        id: 'transactions',
        type: 'single',
      },
      {
        name: 'seller.payments',
        icon: 'seller_payments',
        id: 'seller_payments',
        url: 'payments/sellers',
        type: 'parent',
        children: [
          {
            name: 'info',
            url: 'withdraws/seller',
            id: 'seller_info',
            type: 'single',
            parentId: 'seller_payments',
          },
          {
            name: 'completed.payments',
            url: 'completed-withdraws/seller',
            id: 'seller_completed_payments',
            type: 'single',
            parentId: 'seller_payments',
          },
        ],
      },
      {
        name: 'deliveryman.payments',
        icon: 'deliveryman_payments',
        id: 'deliveryman_payments',
        url: 'payments/deliverymans',
        type: 'parent',
        children: [
          {
            name: 'info',
            url: 'withdraws/deliveryman',
            id: 'deliveryman_info',
            type: 'single',
            parentId: 'deliveryman_payments',
          },
          {
            name: 'completed.payments',
            url: 'completed-withdraws/deliveryman',
            id: 'deliveryman_completed_payments',
            type: 'single',
            parentId: 'deliveryman_payments',
          },
        ],
      },
      {
        name: 'payout.requests',
        icon: 'payout_requests',
        url: 'payout-requests',
        id: 'payout_requests',
        type: 'single',
      },
      {
        name: 'payouts',
        icon: 'payouts',
        url: 'payouts',
        id: 'payouts',
        type: 'single',
      },
    ],
  },
  {
    name: 'report.&.analytics',
    id: 'report_and_analytics',
    type: 'group',
    menus: [
      {
        name: 'overview',
        icon: 'overview',
        url: 'report/overview',
        id: 'overview',
        type: 'single',
      },
      {
        name: 'revenue.reports',
        icon: 'revenue_reports',
        url: 'report/revenue',
        id: 'revenue_reports',
        type: 'single',
      },
      {
        name: 'order.reports',
        icon: 'order_reports',
        url: 'report/orders',
        id: 'order_reports',
        type: 'single',
      },
      {
        name: 'product.reports',
        icon: 'product_reports',
        url: 'report/products',
        id: 'product_reports',
        type: 'single',
      },
      {
        name: 'stock.reports',
        icon: 'stock_reports',
        url: 'report/stock',
        id: 'stock_reports',
        type: 'single',
      },
      {
        name: 'category.reports',
        icon: 'category_reports',
        url: 'report/categories',
        id: 'category_reports',
        type: 'single',
      },
      {
        name: 'extras.reports',
        icon: 'options_extras_reports',
        url: 'report/extras',
        id: 'options_extras_reports',
        type: 'single',
      },
    ],
  },
  {
    name: 'business.settings',
    id: 'business_settings',
    type: 'group',
    menus: [
      {
        name: 'general.settings',
        id: 'general_settings',
        icon: 'general_settings',
        url: 'settings/general',
        type: 'single',
      },
      {
        name: 'currencies',
        id: 'currencies',
        icon: 'currencies',
        url: 'currencies',
        type: 'single',
      },
      {
        name: 'payments',
        id: 'payments',
        icon: 'payments',
        type: 'parent',
        children: [
          {
            name: 'payment.methods',
            id: 'payment_methods',
            url: 'settings/payments',
            type: 'single',
            parentId: 'payments',
          },
          {
            name: 'payment.payloads',
            id: 'payment_payloads',
            url: 'payment-payloads',
            type: 'single',
            parentId: 'payments',
          },
        ],
      },
      {
        name: 'notification.settings',
        id: 'notification_settings',
        icon: 'notification_settings',
        type: 'parent',
        children: [
          {
            name: 'firebase.configuration',
            id: 'firebase_configuration',
            url: 'settings/firebase',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'sms.provider',
            id: 'sms_provider',
            url: 'settings/sms-payload',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'email.provider',
            id: 'email_provider',
            url: 'settings/emailProviders',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'email.templates',
            id: 'email_templates',
            url: 'message/subscriber',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'subscribers',
            id: 'subscribers',
            url: 'subscriber',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'subscribers.messages',
            id: 'subscribers_messages',
            url: 'message/subscriber',
            type: 'single',
            parentId: 'notification_settings',
          },
        ],
      },
      {
        name: 'social.settings',
        id: 'social_settings',
        icon: 'social_settings',
        url: 'settings/social',
        type: 'single',
      },
      {
        name: 'app.settings',
        id: 'app_settings',
        icon: 'app_settings',
        url: 'settings/app',
        type: 'single',
      },
      {
        name: 'page.setup',
        id: 'page_setup',
        icon: 'page_setup',
        url: 'page_setup',
        type: 'parent',
        children: [
          {
            name: 'faq',
            id: 'faq',
            url: 'settings/faqs',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'terms.&.conditions',
            id: 'temrs_and_conditions',
            url: 'settings/terms',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'privacy.policy',
            id: 'privacy_policy',
            url: 'settings/policy',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'custom.pages',
            id: 'custom_pages',
            url: 'pages',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'landing.page',
            id: 'landing_page',
            url: 'settings/landing-page',
            type: 'single',
            parentId: 'page_setup',
          },
        ],
      },
    ],
  },
  {
    name: 'system.settings',
    id: 'system_settings',
    type: 'group',
    menus: [
      {
        name: 'languages.&.translations',
        id: 'languages_and_translations',
        icon: 'languages_and_translations',
        type: 'parent',
        children: [
          {
            name: 'languages',
            id: 'languages',
            url: 'settings/languages',
            type: 'single',
            parentId: 'languages_and_translations',
          },
          {
            name: 'translations',
            id: 'translations',
            url: 'settings/translations',
            type: 'single',
            parentId: 'languages_and_translations',
          },
        ],
      },
      {
        name: 'backup.&.maintenance',
        id: 'backup_and_maintenance',
        icon: 'backup_and_maintenance',
        type: 'parent',
        children: [
          {
            name: 'backup',
            id: 'backup',
            url: 'settings/backup',
            type: 'single',
            parentId: 'backup_and_maintenance',
          },
          {
            name: 'clear.cash',
            id: 'clear_cash',
            url: 'settings/cashClear',
            type: 'single',
            parentId: 'backup_and_maintenance',
          },
        ],
      },
      {
        name: 'system.information',
        id: 'system_information',
        icon: 'system_information',
        url: 'settings/system-information',
        type: 'single',
      },
      {
        name: 'update.database',
        id: 'update_database',
        icon: 'update_database',
        url: 'settings/update',
        type: 'single',
      },
    ],
  },
];

const managerRoutes = filterRoutes(adminRoutes, managerExcludeIds);

const sellerRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    type: 'single',
  },
  {
    name: 'pos',
    icon: 'pos',
    url: 'seller/pos-system',
    id: 'pos',
    type: 'single',
  },
  {
    name: 'wallets',
    icon: 'wallets',
    url: 'seller/wallet',
    id: 'wallets',
    type: 'single',
  },
  {
    name: 'delivery.price',
    icon: 'delivery_price',
    url: 'seller/delivery-price',
    id: 'delivery_price',
    type: 'single',
  },
  {
    name: 'order.management',
    id: 'order_management',
    type: 'group',
    menus: [
      {
        name: 'orders',
        id: 'orders',
        icon: 'orders',
        type: 'parent',
        children: [
          {
            name: 'all',
            label: 'all',
            url: 'seller/orders',
            id: 'all_orders',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'refunds',
            url: 'seller/refunds',
            id: 'refunds',
            type: 'single',
            parentId: 'orders',
          },
        ],
      },
      {
        name: 'order.reviews',
        icon: 'reviews',
        url: 'seller/reviews/order',
        id: 'order_reviews',
        type: 'single',
      },
    ],
  },
  {
    name: 'product.management',
    id: 'product_management',
    type: 'group',
    menus: [
      {
        name: 'products',
        icon: 'products',
        url: 'seller/products',
        id: 'product_list',
        type: 'single',
      },
      {
        name: 'discounts',
        icon: 'discounts',
        url: 'seller/discounts',
        id: 'discounts',
        type: 'single',
      },
      {
        name: 'categories',
        icon: 'product_categories',
        url: 'seller/categories',
        id: 'product_categories',
        type: 'single',
      },
      {
        name: 'looks',
        id: 'looks',
        icon: 'looks',
        url: 'seller/looks',
        type: 'single',
      },
      {
        name: 'extras',
        id: 'options',
        icon: 'options',
        type: 'parent',
        children: [
          {
            name: 'extra.groups',
            url: 'extras',
            id: 'option_group',
            type: 'single',
            parentId: 'options',
          },
          {
            name: 'extra.values',
            url: 'extras/value',
            id: 'option_value',
            type: 'single',
            parentId: 'options',
          },
        ],
      },
      {
        name: 'properties',
        id: 'properties',
        icon: 'properties',
        type: 'parent',
        children: [
          {
            name: 'property.groups',
            url: 'property',
            id: 'property_group',
            type: 'single',
            parentId: 'properties',
          },
          {
            name: 'property.values',
            url: 'property/value',
            id: 'property_value',
            type: 'single',
            parentId: 'properties',
          },
        ],
      },
      {
        name: 'product.reviews',
        id: 'product_reviews',
        icon: 'reviews',
        url: 'seller/reviews/product',
        type: 'single',
      },
    ],
  },
  {
    name: 'shop.management',
    id: 'shop_management',
    type: 'group',
    menus: [
      {
        name: 'my.shop',
        icon: 'my_shop',
        url: 'my-shop',
        id: 'my_shop',
        type: 'single',
      },
      {
        name: 'shop.review',
        icon: 'reviews',
        url: 'seller/shop-reviews',
        id: 'shop_reviews',
        type: 'single',
      },
      {
        name: 'staff.users',
        url: 'seller/shop-users',
        id: 'staff_users',
        icon: 'staff_and_admin_users',
        type: 'single',
      },
    ],
  },
  {
    name: 'promotion.management',
    id: 'promotion_management',
    type: 'group',
    menus: [
      {
        id: 'coupons',
        type: 'single',
        name: 'coupons',
        icon: 'coupons',
        url: 'seller/coupons',
      },
      {
        name: 'product.bonus',
        url: 'seller/bonus/product',
        id: 'product_bonus',
        icon: 'bonuses',
        type: 'single',
      },
      {
        name: 'stories',
        icon: 'stories',
        url: 'seller/stories',
        id: 'seller_stories',
        type: 'single',
      },
      {
        name: 'brands',
        icon: 'brands',
        url: 'seller/brands',
        id: 'brands',
        type: 'single',
      },
    ],
  },
  {
    name: 'business.settings',
    id: 'business_settings',
    type: 'group',
    menus: [
      {
        name: 'my.subscriptions',
        icon: 'my_subscriptions',
        url: 'seller/my-subscriptions',
        id: 'my_subscriptions',
        type: 'single',
      },
      {
        name: 'subscriptions',
        icon: 'subscriptions',
        url: 'seller/subscriptions',
        id: 'subscriptions',
        type: 'single',
      },
      {
        name: 'ad.packages',
        id: 'ad_packages',
        url: 'seller/advert',
        icon: 'ads',
        type: 'single',
      },
      {
        name: 'shop.ads',
        id: 'shop_ads',
        url: 'seller/shop-ads',
        icon: 'ad',
        type: 'single',
      },
    ],
  },
  {
    name: 'transaction.management',
    id: 'transaction_management',
    type: 'group',
    menus: [
      {
        name: 'transactions',
        icon: 'transactions',
        url: 'seller/transactions',
        id: 'transactions',
        type: 'single',
      },
      {
        name: 'payout.requests',
        icon: 'payout_requests',
        url: 'seller/withdraws',
        id: 'payout_requests',
        type: 'single',
      },
      {
        name: 'payouts',
        icon: 'payouts',
        url: 'seller/payouts',
        id: 'payouts',
        type: 'single',
      },
      {
        name: 'payment.payloads',
        icon: 'payments',
        id: 'payment_payloads',
        url: 'seller/payments',
        type: 'single',
      },
    ],
  },
  {
    name: 'report.&.analytics',
    id: 'report_and_analytics',
    type: 'group',
    menus: [
      {
        name: 'order.reports',
        icon: 'order_reports',
        url: 'seller/report/orders',
        id: 'order_reports',
        type: 'single',
      },
    ],
  },
];

const moderatorRoutes = filterRoutes(sellerRoutes, moderatorExcludeIds);

const deliverymanRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    type: 'single',
  },
  {
    name: 'orders',
    url: 'deliveryman/orders',
    id: 'all_orders',
    type: 'single',
    icon: 'orders',
  },
  {
    name: 'payout.requests',
    icon: 'payout_requests',
    url: 'deliveryman/withdraws',
    id: 'payout_requests',
    type: 'single',
  },
];

const waiterRoutes = [
  {
    name: 'my.orders',
    icon: 'orders',
    url: 'waiter/orders-board',
    id: 'my_orders',
    type: 'single',
  },
];

export const data = {
  admin: adminRoutes,
  manager: managerRoutes,
  seller: sellerRoutes,
  moderator: moderatorRoutes,
  deliveryman: deliverymanRoutes,
  waiter: waiterRoutes,
  parcel: parcelRoutes,
};
